// External
import { gql } from "lib/apolloClient";

export const creditsFragment = {
  basicCreditsDetails: gql`
    fragment creditsItem on GradeSubjectTermCreditMap {
      id
      grade {
        id
      }
      subject {
        id
      }
      academicTerm {
        id
        type
      }
      genericTag {
        id
      }
      credit
    }
  `,
};
